module.exports = __webpack_public_path__ + "static/media/GTBSProjectPreview2w1100@1x.6ff88b95.webp";